import { Col, Row } from "react-bootstrap";
import { ESolarSolutionType } from "../../../../shared/oversight-core/enums/sola-solution-type";
import MaterialIcon, {
  MtIcon,
} from "../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import styles from "./solar-solution-type.module.scss";

interface IProps {
  item: {
    id: number;
    icon: MtIcon;
    icon2?: MtIcon;
    title: string;
    solarSolutionType?: ESolarSolutionType;
  };
  onSelect: () => void;
  isSelected?: boolean;
  isDarkMode: boolean;
}

const SolarSolutionType = (props: IProps) => {
  const { item, onSelect, isSelected, isDarkMode = false } = props;

  return (
    <div
      className={`${styles.solarSystemTypeContainer} ${
        isSelected
          ? `bg-danger solar-solution-type-border`
          : `bg-background-4 border-solution-type`
      } cursor-pointer p-3`}
      onClick={onSelect}
    >
      <Row className="align-items-center w-100">
        <Col className="col-auto">
          <Row className="align-items-center">
            <Col className={`d-flex ${item.icon2 ? "pe-1" : ""}`}>
              <MaterialIcon
                icon={item.icon}
                color={isSelected || isDarkMode ? `#ffffff` : `#4d4d84`}
                size={20}
                fill
              />
              {item.icon2 && (
                <div
                  className={`ps-1 ${
                    isSelected ? `text-white` : `solution-type-text`
                  }`}
                >
                  +
                </div>
              )}
            </Col>
            {item.icon2 && (
              <Col className="ps-0">
                <MaterialIcon
                  icon={item.icon2}
                  color={isSelected || isDarkMode ? `#ffffff` : `#4d4d84`}
                  size={20}
                  fill
                />
              </Col>
            )}
          </Row>
        </Col>
        <Col
          className={`${
            isSelected ? `text-white` : `solution-type-text`
          } font-weight-500 font-size-12 ps-0`}
        >
          {item.title}
        </Col>
      </Row>
    </div>
  );
};

export default SolarSolutionType;
